<!--
  Radio group + "Copy from existing (clone & rename)" mode are hidden until the
  backend's /pricelists/{id}/clone endpoint is fixed — see the feature spec's
  Follow-up TODOs. The component still serialises {id} the same way, so
  bringing the radios back is just an HTML change.
-->
<hlm-select
  [options]="options()"
  [searchable]="true"
  placeholder="Select a price list…"
  searchPlaceholder="Search price list…"
  [value]="existingId()"
  (valueChange)="onExistingChange($any($event))"
  [disabled]="disabled()"
/>
